import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { queuesConfigEntrypoint } from '@atlassian/jira-spa-apps-servicedesk-queues-config/entrypoint.tsx';

export const serviceDeskQueuesConfigPageEntryPoint = createPageEntryPoint({
	main: queuesConfigEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
